<template>
    <div class="qrcode">
        <img v-if="system === 'android' && !err && neizhi && !isAlipay" class="activityPicture"
             :src="androidImg"/>
        <img v-if="system === 'ios' && !err && neizhi" class="activityPicture" :src="iosImg"/>
        <img v-if="!err && !neizhi"  :src="commonImg" />
        <img v-if="err" class="activityPicture" src="../assets/404.png"/>
    </div>
</template>

<script>
    export default {
        name: 'qrcode',
        props: {
            msg: String
        },
        created() {
            console.log(window.location, 1111111)
            let url = window.location.href; //获取当前url
            let dz_url = url.split('#')[0]; //获取#/之前的字符串
            let cs = dz_url.split('?')[1]; //获取?之后的参数字符串
            console.log(url, dz_url, cs)
            if (cs) {
                let cs_arr = cs.split('&'); //参数字符串分割为数组
                cs = {};
                for (let i = 0; i < cs_arr.length; i++) {
                    cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
                }
                console.log(cs)
                this.appcode = cs.appcode ? window.decodeURIComponent(cs.appcode) : '中仑掌柜'
                console.log(window.decodeURIComponent(cs.appcode))
                console.log(this.appcode)
                console.log(this.appList)
                if (this.appList[this.appcode]) {
                    console.log('已配置')
                    this.androidImg = this.appList[this.appcode].androidImg || ''
                    this.iosImg = this.appList[this.appcode].iosImg || ''
                    this.commonImg = this.appList[this.appcode].commonImg || ''
                    console.log(this.androidImg,this.iosImg)
                    document.title = (this.appList[this.appcode].name || '中仑掌柜') + 'APP下载'
                }
                console.log(this.appcode)
            }else{
                this.appcode = '中仑掌柜'
                if (this.appList[this.appcode]) {
                    console.log('已配置')
                    this.androidImg = this.appList[this.appcode].androidImg || ''
                    this.iosImg = this.appList[this.appcode].iosImg || ''
                    document.title = (this.appList[this.appcode].name || '中仑掌柜') + 'APP下载'
                }
            }
            this.neizhi = this.is_neizhi();
            this.getSystem();
        },
        data() {
            return {
                appList: {
                    '中仑掌柜': {
                        name: '中仑掌柜',
                        androidImg: require('../assets/guide_Android.png'),
                        iosImg: require('../assets/guide_IOS.png'),
                        commonImg: require('../assets/common.png'),
                    },
                    'POSASSISTANT_APP-001': {
                        name: '银响力零售',
                        androidImg: require('../assets/POSASSISTANT_APP_Android.png'),
                        iosImg: require('../assets/POSASSISTANT_APP_IOS.png'),
                        commonImg: require('../assets/yxl_common.png'),
                    },
                    'BJYX-A0FE821': {
                        name: '冰佳优选',
                        androidImg: require('../assets/BJYX_Android.png'),
                        iosImg: require('../assets/BJYX_IOS.png'),
                        commonImg: require('../assets/BJYX_common.png'),
                    },
                    'HCMTX-3238DC0': {
                        name: '华创满天星',
                        androidImg: require('../assets/HCMTX_Android.png'),
                        iosImg: require('../assets/HCMTX_IOS.png'),
                        commonImg: require('../assets/HCMTX_common.png'),
                    },
					'JHSLS-B447AFE': {
					    name: '久合盛零售',
					    androidImg: require('../assets/JHSLS_Android.png'),
					    iosImg: require('../assets/JHSLS_IOS.png'),
					    commonImg: require('../assets/JHSLS_common.png'),
					},
					'HSZHSY-96DCBA4': {
					    name: '浩顺智慧收银',
					    androidImg: require('../assets/HSZHSY_Android.png'),
					    iosImg: require('../assets/HSZHSY_IOS.png'),
					    commonImg: require('../assets/HSZHSY_common.png'),
					},
                    'KJJZHMD-B308C08': {
					    name: '客聚集智慧门店',
					    androidImg: require('../assets/KJJZHMD_Android.png'),
					    iosImg: require('../assets/KJJZHMD_IOS.png'),
					    commonImg: require('../assets/KJJZHMD_common.png'),
					},
                    'SJYG-A5A54EE': {
					    name: '熵基易购',
					    androidImg: require('../assets/SJYG_Android.png'),
					    iosImg: require('../assets/SJYG_IOS.png'),
					    commonImg: require('../assets/SJYG_common.png'),
					},
                    'zsjg-D74D679': {
					    name: '掌上监管',
					    androidImg: require('../assets/zsjg_Android.png'),
					    iosImg: require('../assets/zsjg_IOS.png'),
					    commonImg: require('../assets/zsjg_common.png'),
					},
                    'yxlnm-1356F35': {
                        name: '银响力农贸',
                        androidImg: require('../assets/yxlnm_Android.png'),
                        iosImg: require('../assets/yxlnm_IOS.png'),
                        commonImg: require('../assets/yxlnm_common.png'),
                    },
                    '汇邻农贸': {
                        name: '汇邻农贸',
                        androidImg: require('../assets/hlnm_Android.png'),
                        iosImg: require('../assets/hlnm_IOS.png'),
                        commonImg: require('../assets/hl_common.png'),
                    },
                    '久合盛智慧市场': {
                        name: '久合盛智慧市场',
                        androidImg: require('../assets/jhs_Android.png'),
                        iosImg: require('../assets/jhs_IOS.png'),
                        commonImg: require('../assets/jhs_common.png'),
                    },
                    '智慧农贸': {
                        name: '智慧农贸',
                        androidImg: require('../assets/zhnm_Android.png'),
                        iosImg: require('../assets/zhnm_IOS.png'),
                        commonImg: require('../assets/zh_common.png'),
                    },
                    '普盛收银管家': {
                        name: '普盛收银管家',
                        androidImg: require('../assets/ps_Android.png'),
                        iosImg: require('../assets/ps_IOS.png'),
                        commonImg: require('../assets/ps_common.png'),
                    },
                    '数邦菜': {
                        name: '数邦菜',
                        androidImg: require('../assets/sbc_Android.png'),
                        iosImg: '',
                        commonImg: require('../assets/sbc_common.png'),
                    },
                    '中仑供应链': {
                        name: '中仑供应链',
                        androidImg: require('../assets/gyl_Android.png'),
                        iosImg: require('../assets/gyl_IOS.png'),
                        commonImg: require('../assets/gyl_common.png'),
                    },
					'JHSNM-B15F063': {
					    name: '久合盛农贸',
					    androidImg: require('../assets/JHSLS_Android.png'),
					    iosImg: require('../assets/JHSLS_IOS.png'),
					    commonImg: require('../assets/JHSLS_common.png'),
					},
					'SBS-A3400BE': {
					    name: '钞博士',
					    androidImg: require('../assets/SBS_Android.png'),
					    iosImg: require('../assets/SBS_IOS.png'),
					    commonImg: require('../assets/SBS_common.png'),
					},
					'YKM-214E5B4': {
					    name: '赢客猫',
					    androidImg: require('../assets/YKM_Android.png'),
					    iosImg: require('../assets/YKM_IOS.png'),
					    commonImg: require('../assets/YKM_common.png'),
					},
					'SXT-DB66727': {
					    name: '银响力生鲜通',
					    androidImg: require('../assets/YXLSXT_Android.png'),
					    iosImg: require('../assets/YXLSXT_IOS.png'),
                        commonImg: require('../assets/yxl_common.png'),
					},
                    'JJH-951BADF': {
					    name: '今嘉惠',
					    androidImg: require('../assets/JJH_Android.png'),
					    iosImg: require('../assets/JJH_Android.png'),
                        commonImg: require('../assets/jjh_common.png'),
					},
                    'XGXZ-4C8D0FB': {
					    name: '仙果小镇',
					    androidImg: require('../assets/XGXZ_Android.png'),
					    iosImg: require('../assets/XGXZ_Android.png'),
                        commonImg: require('../assets/xgxz_common.png'),
					},
                    'BLH-030EB4A': {
					    name: '便利欢',
					    androidImg: require('../assets/BLH_Android.png'),
					    iosImg: require('../assets/BLH_Android.png'),
                        commonImg: require('../assets/blh_common.png'),
					},
                    'SKPZ-E822B77': {
					    name: '食客铺子',
					    androidImg: require('../assets/SKPZ_Android.png'),
					    iosImg: require('../assets/SKPZ_Android.png'),
                        commonImg: require('../assets/skpz_common.png'),
					},
                    'MRC-1B501DD': {
					    name: '每日臣',
					    androidImg: require('../assets/MRC_Android.png'),
					    iosImg: require('../assets/MRC_Android.png'),
                        commonImg: require('../assets/mrc_common.png'),
					},
                    'XPZ-1C23506': {
					    name: '鲜棚子',
					    androidImg: require('../assets/XPZ_Android.png'),
					    iosImg: require('../assets/XPZ_Android.png'),
                        commonImg: require('../assets/xpz_common.png'),
					},
                    'ZSGJ-40F729E': {
					    name: '追溯管家',
					    androidImg: require('../assets/ZSGJ_Android.png'),
					    iosImg: require('../assets/ZSGJ_Android.png'),
                        commonImg: require('../assets/zsgj_common.png'),
					},
                },
                appcode: '中仑掌柜',
                name: '中仑掌柜',
                neizhi: '',
                androidImg: require('../assets/guide_Android.png'),
                iosImg: require('../assets/guide_IOS.png'),
                commonImg: require('../assets/common.png'),
                isAlipay: false,
                system: 'android',
                err: false
            };
        },
        methods: {
            is_neizhi() {
                // else if (ua.match(/QQ/i) == 'qq') {
                // 	return true;
                // }
                let ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    return true;
                } else if (ua.match(/Alipay/i) == 'alipay') {
                    this.isAlipay = true;
                    return true;
                }
                return false;
            },
            getSystem() {
                let version = navigator.userAgent.toLowerCase();
                // console.log(version);
                // PC端不需要做任何操作
                if (version.indexOf('iphone') > -1) {
                    //苹果手机
                    this.system = 'ios';
                } else {
                    // 安卓手机
                    this.system = 'android';
                }
                this.getInstallationPackage();
            },
            getInstallationPackage() {
                this.err = false;
                let api = `https://cashapp.zhonglunnet.com/zl.cashapp.uesr.queryCashAppUpdateConfig/1.0.0/action?name=${this.appcode}&version=0.0.0`;
                this.axios
                    .get(api)
                    .then(res => {
                        console.log('====res',res);
                        // 如果接口访问成功
                        if (res.data.success == '1') {
                            // return;
                            let pkgurl = res.data.data.pkgurl ? JSON.parse(res.data.data.pkgurl) : {};
                            console.log(pkgurl);
                            if (!pkgurl.ios && !pkgurl.android) {
                                return
                            }
                            // 系统是苹果系统，直接调起App Store
                            if (this.system === 'ios') {
                                if (pkgurl.ios !== '') {
                                    window.location.href = pkgurl.ios;
                                }
                            } else if (this.system === 'android') {
                                // 否则就是安卓手机
                                if ((!this.neizhi || (this.neizhi && this.isAlipay)) && pkgurl.android !== '') {
                                    // 如果不是微信、QQ、支付宝的扫一扫打开的页面，直接下载
                                    window.location.href = pkgurl.android;
                                }
                            }
                        } else {
                            this.err = true;
                        }
                    })
                    .catch(err => {
                        console.log('===err',err)
                        this.err = true;
                    });
            }
        }
    };
</script>
<style scoped>
    .qrcode {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    img {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
</style>
